<header dialog-header>
  <h4>{{ dialog?.value?.title || value?.title }}</h4>
  <button class="close-btn" (click)="close()">
    <app-icon name="cross" width="16px" height="16px" />
  </button>
</header>

@if (dialog?.value?.message || value?.message) {
  <p>{{ dialog?.value?.message || value?.message }}</p>
}
@if (dialog?.value?.innerHtml) {
  <p [innerHTML]="dialog?.value?.innerHtml"></p>
}

@if (dialog?.actions || actions; as actions) {
  <div dialog-actions>
    @for (action of actions; track action) {
      @if (action?.text) {
        <button (click)="action?.act && act(action.act)" [type]="action?.buttonType" ui-button size="small">
          {{ action.text }}
        </button>
      }
    }
  </div>
}
